/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetDevice} from '../api'

export const useMutationResetDevice = createReactQueryMutationHook('resetDevice', resetDevice)
